const KEY = "fsc_ref";
const TTL = 60 * 24 * 3600 * 1000;

export function captureRef(search) {
  const code = new URLSearchParams(search).get("ref");
  if (code && /^[A-Za-z0-9]{4,12}$/.test(code)) localStorage.setItem(KEY, JSON.stringify({ code: code.toUpperCase(), at: Date.now() }));
}

export function readRef() {
  try {
    const v = JSON.parse(localStorage.getItem(KEY));
    return v && Date.now() - v.at < TTL ? v.code : "";
  } catch {
    return "";
  }
}

export const pct = (v) => `${String(Number(v) || 0).replace(".", ",")}%`;
